import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import Layout from "../layouts/Layout";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/dashboard/Dashboard";
// import Family from "../pages/myfamily/MyFamily";
import MyFamily from "../pages/myfamily/MyFamily";
import AppointmentDairy from "../pages/appointmentdairy/AppointmentDairy";
import Directory from "../pages/directory/Directory";
import ProviderPage from "../pages/registration/ProviderPage";
import ServiceCoordinatorPage from "../pages/registration/ServiceCoordinatorPage";
// import ChildProgress from "../pages/child-progress/ChildProgress";

const AppRoutes = () => {
    return (
        <Routes>
            {/* Redirect "/" to "/login" */}
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />

            {/* Protected Routes inside Layout */}
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="serviceprovider" element={<ProviderPage/>} />
                <Route path="servicecoordinator" element={<ServiceCoordinatorPage/>} />
                <Route path="myfamily" element={<MyFamily />} />
                <Route path="appointmentdairy" element={<AppointmentDairy />} />
                <Route path="directory" element={<Directory/>} />
                
                {/* <Route path="child-progress" element={<ChildProgress />} /> */}
            </Route>
        </Routes>
    );
};

export default AppRoutes;
